import React, { useState } from "react";
import { useSelector } from "react-redux";
import issueTicketManually from "../../../../../controllers/booking/issueTicketManually";
import { enqueueSnackbar } from "notistack";
import Modal1 from "../../../../../components/DIsplay/Modal/Modal1";
import { ManualTicketForm } from "../../../../Orders/ApproveTicket";
import Button1 from "../../../../../components/form/Button1";
import { Modal3 } from "../../../../../components/DIsplay/Modal/Modal3";
import PinForm from "../../../../../components/Settings/PinForm";

function ManageOrderManualIssueModal({ modal, setModal, booking }) {
  const { user } = useSelector((state) => state.user?.userData);
  const [loading, setLoading] = useState(false);
  const [openPin, setOpenPin] = useState(false);
  const [bookingItem, setBookingItem] = useState(booking);

  async function handleManualIssue(pin) {
    if (!pin && user?.advancedSecurityEnabled)
      return setOpenPin({
        callback: (pin) => handleManualIssue(pin),
      });

    const reqBody = {
      ticketQueueId: bookingItem?._id,
      travelerTicket: bookingItem?.travelerTicket,
      pin,
    };
    setLoading(true);
    const res = await issueTicketManually(reqBody).finally(() =>
      setLoading(true)
    );
    if (res.return) {
      enqueueSnackbar("Ticket has been issued.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  return (
    <div>
      <Modal3 title={"PIN"} open={openPin} setOpen={() => setOpenPin(false)}>
        <PinForm
          callback={(pin) => {
            setOpenPin(false);
            openPin?.callback && openPin?.callback(pin);
          }}
          close={() => setOpenPin(false)}
        />
      </Modal3>
      <Modal1
        open={modal?.manualIssue}
        setOpen={(modalState) =>
          setModal({ ...modal, manualIssue: modalState })
        }
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>Ticket Number?</h5>
          <ManualTicketForm
            travelers={bookingItem?.flightBooking?.at(0)?.travelers}
            flightData={bookingItem}
            onChange={(obj) =>
              setBookingItem({ ...bookingItem, travelerTicket: obj })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, manualIssue: false })}
            >
              Cancel
            </Button1>
            <div>
              <Button1 onClick={() => handleManualIssue()} loading={loading}>
                Issue Ticket
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>
    </div>
  );
}

export default ManageOrderManualIssueModal;
